module.exports = __webpack_public_path__ + "img/user-placeholder.c7d7c578.png";